import { render, staticRenderFns } from "./DatosTarjetasForm.vue?vue&type=template&id=1a2e4b35&scoped=true"
import script from "./DatosTarjetasForm.vue?vue&type=script&lang=js"
export * from "./DatosTarjetasForm.vue?vue&type=script&lang=js"
import style0 from "./DatosTarjetasForm.vue?vue&type=style&index=0&id=1a2e4b35&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a2e4b35",
  null
  
)

export default component.exports